var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FeathersVuexFind", {
    attrs: {
      service: "cases",
      fetchQuery: _vm.fetchQuery,
      params: _vm.params,
      watch: "params",
      queryWhen: Number.isInteger(_vm.scenario_id),
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var items = ref.items
          return [
            _c(
              "InputSelect",
              _vm._b(
                {
                  attrs: {
                    label: "Case",
                    "search-input": _vm.searchInput,
                    items: items,
                    "item-text": "name",
                    "item-value": "id",
                    loading: _vm.caseLoadPending || _vm.caseSavePending,
                    "save-as-rules": _vm.saveAsRules,
                    "rename-rules": _vm.renameRules,
                  },
                  on: {
                    "update:searchInput": function ($event) {
                      _vm.searchInput = $event
                    },
                    "update:search-input": function ($event) {
                      _vm.searchInput = $event
                    },
                    create: _vm.create,
                    rename: _vm.rename,
                    "save-as": function ($event) {
                      return _vm.$emit("save-as", $event)
                    },
                  },
                  model: {
                    value: _vm.case_id,
                    callback: function ($$v) {
                      _vm.case_id = $$v
                    },
                    expression: "case_id",
                  },
                },
                "InputSelect",
                _vm.$attrs,
                false
              )
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }